export default __webpack_public_path__ + "static/media/logowhite.3ac72361.svg";